import { Layout } from "antd";
import { ReactComponent as ArrowRight } from "assets/icons/arrow-right-with-line.svg";
import { ReactComponent as Close } from "assets/icons/close.svg";

const { Header } = Layout;

const PageHeader = ({
  loading,
  isScrolled,
  title,
  showBackArrow,
  goBack,
}) => {
  const renderBackBtn = () => {
    return showBackArrow ? (
      <div className="cursor-pointer">
        <ArrowRight onClick={() => goBack()} />
      </div>
    ) : (
      <div />
    );
  };

  return (
    <Header
      className={`fixed h-auto top-0 px-5 w-full max-w-2xl mx-auto py-3 z-40 transition-colors duration-300 ${
        isScrolled ? "bg-white" : "bg-transparent"
      }`}
    >
      <div className=" flex justify-between items-center ">
        {renderBackBtn()}

        <span className="text-gray-0 body-14px-regular">
          {!loading ? title : ""}
        </span>
        <div />
      </div>
    </Header>
  );
};

export default PageHeader;
